module.exports = __webpack_public_path__ + "static/media/home-bg-1.8e8e7154.png";